import { createFileRoute } from '@tanstack/react-router'

import { SecurityPanel } from '@/features/user/profile'

export const Route = createFileRoute('/_event/minha-conta/seguranca')({
  component: SecurityPanel
})
